export default __webpack_public_path__ + "static/media/main-tab-arrow-up.3e63d9ca.svg";